<template>
    <div>
        <b-row>
<!--            <b-col cols="6">-->
<!--                <b-form-group :label="$t('campus_name')">-->
<!--                    <b-input-group>-->
<!--                        <div class="label-as-input">{{ isNotNullValue(form.campus_name) }}</div>-->
<!--                    </b-input-group>-->
<!--                </b-form-group>-->
<!--            </b-col>-->
            <b-col cols="6">
                <b-form-group :label="$t('building')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.building_name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>

            <b-col cols="6">
                <b-form-group :label="$t('name')">
                    <b-input-group >
                        <div class="label-as-input">{{ isNotNullValue(form.name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>

            <b-col cols="6">
                <b-form-group :label="$t('capacity')">
                    <b-input-group :prepend="$t('class')">
                        <div class="label-as-input">{{ isNotNullValue(form.capacity) }}</div>
                    </b-input-group>
                    <b-input-group :prepend="$t('exam')">
                        <div class="label-as-input">{{ isNotNullValue(form.exam_capacity) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>

            <b-col cols="4">
                <b-form-group :label="$t('classroom_types')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.type) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>

<!--            <b-col cols="4">-->
<!--                <b-form-group :label="$t('seating_types')">-->
<!--                    <b-input-group>-->
<!--                        <div class="label-as-input">{{ isNotNullValue(form.seating_type) }}</div>-->
<!--                    </b-input-group>-->
<!--                </b-form-group>-->
<!--            </b-col>-->

<!--            <b-col cols="4">-->
<!--                <b-form-group :label="$t('board_types')">-->
<!--                    <b-input-group>-->
<!--                        <div class="label-as-input">{{ isNotNullValue(form.board_type) }}</div>-->
<!--                    </b-input-group>-->
<!--                </b-form-group>-->
<!--            </b-col>-->

<!--            <b-col cols="4">-->
<!--                <b-form-group :label="$t('display_systems')">-->
<!--                    <b-input-group>-->
<!--                        <div class="label-as-input">{{ isNotNullValue(form.display_system) }}</div>-->
<!--                    </b-input-group>-->
<!--                </b-form-group>-->
<!--            </b-col>-->

<!--            <b-col cols="4">-->
<!--                <b-form-group :label="$t('sound_systems')">-->
<!--                    <b-input-group>-->
<!--                        <div class="label-as-input">{{ isNotNullValue(form.sound_systems) }}</div>-->
<!--                    </b-input-group>-->
<!--                </b-form-group>-->
<!--            </b-col>-->

            <b-col cols="4">
                <b-form-group :label="$t('status')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.status) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>

            <b-col cols="12">
                <b-form-group :label="$t('explanation')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.explanation) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    //Service
    import ClassroomService from '@/services/ClassroomService';

    export default {
        props: {
            formId: {
                type: Number
            }
        },
        data() {
            return {
                form: {
                    campus_id: null,
                    building_id: null,
                    capacity: null,
                    exam_capacity: null,
                    type: null,
                    seating_type: null,
                    board_type: null,
                    display_system: null,
                    sound_system: null,
                    status: null,
                    explanation: null,
                    name: null,
                }
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                ClassroomService.get(id)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.formLoading = false;
                                })
                                .catch((error) => {
                                    this.showErrors(error)
                                });
            }
        }
    }
</script>
